import { RootState } from "apps/store";

export const weatherSelector = (state: RootState) => state.weather.weather

export const enableWeatherSelector = (state: RootState) => state.weather.enableWeather

export const loadingWeatherSelector = (state: RootState) => state.weather.loadingWeather

export const errorWeatherSelector = (state: RootState) => state.weather.errorWeather
